<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { buildMeta } from "~~/utils/meta-builder";

const config = useRuntimeConfig()


//const story = await useAsyncStoryblok('blog', { version: config.public.blog.mode })
// get multiple links
// /v2/cdn/links/?starts_with=posts/
// TODO implement this https://www.storyblok.com/docs/api/content-delivery/v2#core-resources/links/retrieve-multiple-links
const route = useRoute()

//router.currentRoute.value
const getSlug = (item: any): string=>{
	if(!item)return ''
	const slug= (item.full_slug as string).split('/')
	//.replace(`${item.lang}/`,'')
	return 'posts/' + slug[slug.length-1]
}

const api = useStoryblokApi();
const i18n = useI18n()
const lang = i18n.locale.value

const i18nHead = useLocaleHead({
	addSeoAttributes: true
}) 

//get all categories
const categoriesData = await api.get("cdn/stories", { 
	version: config.public.blog.mode, 
	starts_with: "blog",
	language: lang === 'en' ? 'default' : lang 
}) 

const	categoryAll = {
	content: {
		name: 'All',
	},
	full_slug: '/blog/all',
	slug: 'all'
}
const categories = [categoryAll, ...categoriesData.data.stories as Array<any>]
	//add category (All) to clear filter
console.log('category first:',categories[0])

const enSlug = ref('/blog')
const deSlug = ref('/de/blog')

//console.log('categories:', categories) 

const { data } = await api.get("cdn/stories", { 
	version: config.public.blog.mode, 
	starts_with: "posts",
	language: lang === 'en' ? 'default' : lang,
 });
//025b3022-b031-4e3a-a1fe-56cccdb9486a --- All
//const state = reactive({ stories: data.stories });
const stories = data.stories as Array<any>
for(var story of stories){
	const resolvedCategories:any[] = []
	//console.log("story.content.category", story.content.category)
	if(story.content.category){
		for(const categoryId of story.content.category){
			const index = categories.findIndex(category=>category.uuid === categoryId)
		
			if(index !== -1){
			//	console.log('uuid', categoryId)
				resolvedCategories.push(categories[index])
			}
			
		}
		story.content['categories'] = resolvedCategories;
	}
	//console.log("resolvedCategories", resolvedCategories)
}	

const featured = stories.filter(x=>x.content.featured)
const filtered = ref<any[]>([])

const filterByCategory = () => {

	let categorySlug: string = route.query.category?.length
		? route.query.category as string 
		: 'all' //redirect

	console.log('filter by', categorySlug)
	console.log('totalPosts', stories.length)

	const filterByAll = categorySlug === 'alle' || categorySlug === 'all' || categorySlug === ''

	const list = stories.filter((s:any)=> !s.content.featured && 
		s.content?.categories?.some((c: any) => filterByAll || translatedPath(c.full_slug) === categorySlug )	
	)
	console.log('list.length:', list.length)
	filtered.value = list
	const currentCategory = categories?.find((x:any)=>x.slug === categorySlug) ?? categories?.find((c:any)=>translatedPath(c.full_slug) === categorySlug)
	const de = currentCategory?.translated_slugs?.find((x:any) => x.lang === 'de').path.split('/')[1] ?? 'all'//alle
	enSlug.value = '/blog?category=' + (currentCategory?.slug ?? 'all')
	deSlug.value = '/de/blog?category='+ de 

	const deUrl = config.public.hostname+deSlug.value
	const enUrl = config.public.hostname+enSlug.value

	useHead(buildMeta({
		key: 'blog', 
		follow: true,
		localeLinks: [
			{ rel: 'alternate', href: enUrl, hreflang: 'en' },
			{ rel: 'alternate', href: enUrl, hreflang: 'en-US' },
			{ rel: 'alternate', href: enUrl, hreflang: 'x-default' },
			{ rel: 'alternate', href: deUrl, hreflang: 'de' },
			{ rel: 'alternate', href: deUrl, hreflang: 'de-DE' },
			{ rel: 'canonical', href: config.public.hostname+route.fullPath},
		]
	},i18n, i18nHead))
}

filterByCategory()

//console.log('data:', data) 

watch(() => route.query, ()=> {
	console.log('query changed:',  route.query.category)
	filterByCategory()
})

//console.log('categories data::', categories)

</script>
<template>
	<div class="bg-newdark-800 text-white">
		<Header theme="dark" />
	
		<div class="w-full max-w-screen-xl mx-auto px-10">

			<PostItemFeatured v-for="item in featured" :key="item.id" :blok="item.content" :slug="getSlug(item)" />
			<NuxtLayout >
				<div class="flex flex-wrap justify-center lg:justify-start gap-x-2 md:gap-x-6 gap-y-6 pt-16 overflow-x-scroll">
					<NuxtLink
					class="px-6 py-2 hover:text-white"
					:class="{' text-newdark-800 bg-white rounded-full hover:bg-white/10': ($route.query.category ?? (i18n.locale.value === 'de' ? 'alle' : 'all')) == translatedPath(category.full_slug),
					'text-white/50': ($route.query.category ?? (i18n.locale.value === 'de' ? 'alle' : 'all')) !== translatedPath(category.full_slug)
				}" 
					 v-for="category in categories" 
				
					:to="'blog?category='+translatedPath(category.full_slug)"
					>{{ category.content.name }}</NuxtLink>
				</div>

				<!-- <NuxtPage :stories="stories" :categories="categories" /> -->

				<div class="gap-8 pt-16 masonry sm:masonry-sm md:masonry-md"> 
					<transition-group name="list">
						<PostItem v-for="item in filtered" :key="item.id" :blok="item.content" :slug="getSlug(item)" />
					</transition-group>
				</div>

			</NuxtLayout>
			
		</div>

		<!-- <StoryblokComponent v-if="story" :blok="story.content"  /> -->
		<Footer theme="dark" :de-slug="deSlug" :en-slug="enSlug" />
	</div>
</template>
<style scoped>
.list-move,
.list-enter-active,
.list-leave-active {
  transition: all .5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
	transform: translateY(30px);
}
.list-leave-active {
  position: absolute;
	max-width: 300px;
}

</style>